import { Checkbox, FormControlLabel } from "@mui/material";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { Input } from "../../../../components/Input/input";
import { theme } from "../../../../helpers/theme";
import { StyledPopover } from "./styled-popover";

interface AdditionalServicesPopoverProps {
  additionalServices: string[];
  setAdditionalServices: (element: string[]) => void;
}

const AdditionalServicesPopover = ({
  additionalServices,
  setAdditionalServices,
}: AdditionalServicesPopoverProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setAdditionalServices([...additionalServices, e.target.name]);
    } else {
      const filteredOptions = [...additionalServices].filter(
        (option) => option !== e.target.name
      );
      setAdditionalServices(filteredOptions);
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const options = [
    "Etykietowanie",
    "Pakowanie",
    "Sortowanie",
    "E-commerce",
    "Wysyłka",
    "Inne",
  ];
  return (
    <AdditionalServicesPopoverContainer>
      {" "}
      <Input
        label="Usługi dodatkowe"
        id="additionalServices"
        name="additionalServicesv"
        value={additionalServices}
        onClick={(e) => handleClick(e)}
        variant="filled"
        style={{ width: "100%", caretColor: "transparent" }}
        focused={false}
      />
      <StyledPopover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <PopoverContentContainer>
          <LocationWrapper>
            {options.map((item) => (
              <FormControlLabel
                key={item}
                value={item}
                control={
                  <Checkbox
                    onChange={(e) => handleChange(e)}
                    name={item}
                    checked={additionalServices.includes(item)}
                  />
                }
                label={item}
              />
            ))}
          </LocationWrapper>
        </PopoverContentContainer>
      </StyledPopover>
    </AdditionalServicesPopoverContainer>
  );
};

export default AdditionalServicesPopover;

const AdditionalServicesPopoverContainer = styled.div`
  width: 20%;
`;
const PopoverContentContainer = styled.div`
  padding: 20px;
  width: 163px;
  height: 300px;
  background-color: white;
`;
const LocationWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const LocationName = styled.span`
  font-family: ${theme.fonts.interMedium};
  cursor: pointer;
`;
